import useAsyncData from "../../../../hooks/use-async-data";
import CargoCompanyDispatchListParams from "./cargo-company-dispatch-list-params";
import CargoCompanyDispatchList from "./cargo-company-dispatch-list";
import cargoCompanyService from "../../cargo-company.service";

const useCargoCompanyDispatchList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyDispatchList>({ data: [], totalCount: 0 });

  const load = async (
    params: CargoCompanyDispatchListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyDispatch = await cargoCompanyService.getDispatchList(
        params,
        signal,
      );

      setData(cargoCompanyDispatch);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useCargoCompanyDispatchList;
